import React, {useEffect, useState} from 'react';
import {useNavigate, useOutletContext} from "react-router-dom";
import {setComma, splitDateTime} from "../../../utils/format";
import {getMemberChargeList} from "../../../api/transaction/chargeApi";
import InfiniteScrollSentinel from "../../../components/common/InfiniteScrollSentinel";
import {useInfiniteScroll} from "../../../hooks/useInfiniteScroll";
import {EmptyState} from "../../../components/common/EmptyStateProps";
import {OutletContextType} from "../../../types/common/oulet.comtext.types";

export default function ChargeListPage() {
    const navigate = useNavigate();
    const {searchTypes, setTotalSize, searchTrigger} = useOutletContext<OutletContextType>();


    const [loading, setLoading] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);

    const {
        accumulatedRows,
        showMoreButton,
        nextPage,
        appendPageData,
        resetPageData,
    } = useInfiniteScroll();

    const handleSearch = async () => {
        try {
            setLoading(true);
            const response = await getMemberChargeList({
                ...searchTypes,
                page: 1
            });
            if (response?.data?.data) {
                resetPageData(response.data.data, searchTypes.size ?? 5);
                setTotalSize(response.data.data.totalSize || 0);
            }
        } catch (err) {
            console.error('충전 내역 에러:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleLoadMore = async () => {
        try {
            setLoadingMore(true);
            const response = await getMemberChargeList({
                ...searchTypes,
                page: nextPage,
            });

            if (response?.data?.data) {
                appendPageData(response.data.data, searchTypes.size ?? 5);
            }
        } catch (err) {
            console.error('더보기 에러:', err);
        } finally {
            setLoadingMore(false);
        }
    };


    useEffect(() => {
        handleSearch();
    }, [searchTrigger]);


    return (
        <>
            {loading ? (
                <section className="bg-white no-gap">
                    <div className="inner-box">
                        <p>데이터를 불러오는 중...</p>
                    </div>
                </section>
            ) : !accumulatedRows || accumulatedRows.length === 0 ? (
                <EmptyState message="충전내역이 비어있습니다."/>
            ) : (
            <section className="bg-white no-gap">
                <div className="inner-box">
                    {accumulatedRows.map((charge: any, index: number) => {
                        const isPlus = charge.chargeType !== "CHARGE_CANCEL";
                        const statusText = isPlus ? "충전완료" : "충전취소";

                        const paymentMethod = charge.paymentMethod === "ADJUSTMENT" ? "관리자 지급" : "계좌이체";
                        const { date, time } = splitDateTime(charge.regDate);
                        const contents = "WINPAY 충전";

                        return (
                        <div
                            key={charge.id || index}
                            className="payment-wrap"
                            onClick={() => navigate(`/wallet/charge-list/${charge.transactionCode}`)}
                            style={{cursor: "pointer"}}
                        >
                            <div className="payment-info">
                                <div className="info-row">
                                    <div className="time">
                                        {date}
                                        <em className="line">{time}</em>
                                    </div>
                                    <div
                                        className={isPlus ? "status finish" : "status cancel"}>{statusText}</div>
                                </div>
                                <div className="info-row">
                                    <div className="cont">{contents}</div>
                                    <div
                                        className={isPlus ? "amount" : "amount text-red"}>{isPlus ? "+" : "-"}{setComma(charge.amount)}원
                                    </div>
                                </div>
                                <div className="info-row">
                                    <div className="method">{paymentMethod}</div>
                                </div>
                            </div>
                        </div>
                    )}
                    )}
                </div>
            </section>
            )}
            <InfiniteScrollSentinel
                showMore={showMoreButton}
                loadingMore={loadingMore}
                loading={loading}
                onLoadMore={handleLoadMore}
            />
        </>
    );
}
